import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useGetHallTableJackpotsQuery } from '../../api/jackpot'
import Preloader from '../Common/Preloader'
import CurrentTable from './current-table'
import JackpotError from './error'

interface TableJackpotsProps {
  hallId: number
  setJackpotId: (id: number) => void
  deleteJackpot: (id: number, name: string) => void
}

const TableJackpots: React.FC<TableJackpotsProps> = ({ hallId, setJackpotId, deleteJackpot }) => {
  const [t] = useTranslation()
  const { currentData: data, isFetching, error } = useGetHallTableJackpotsQuery(hallId, { skip: !hallId })
  return <Box mt={4}>
    <h3>{t('ru.jackpots.table_jackpots')}</h3>
    {isFetching ? <Preloader /> : error ? <JackpotError error={error} /> : data?.jackpots.length ? (
      <CurrentTable hall_id={hallId} jackpots={data.jackpots} tables={data.tables} setJackpotId={setJackpotId} deleteJackpot={deleteJackpot} />
    ) : <Typography>{t('ru.jackpots.no_table_jackpots')}</Typography>}
  </Box>
}

export default TableJackpots
